
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {fetchUnmappedImpressions} from 'redux/modules/settings/actions'
import {Table, Column, Cell} from 'components/Table'
import {getUnmappeImpressions} from 'redux/modules/settings/selectors'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'
import propsChanged from 'utils/propsChanged'

export class ImpressionView extends React.Component {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    fetchUnmappedImpressions: PropTypes.func,
    unmappedImpressions: PropTypes.array,
    isUnmappedImpressionFetching: PropTypes.bool
  }

  componentWillMount() {
    const {timezone} = this.context
    const {startDate, endDate, fetchUnmappedImpressions} = this.props
    fetchUnmappedImpressions(startDate, endDate, timezone)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {timezone} = nextContext
    const {startDate, endDate, fetchUnmappedImpressions} = nextProps

    if (propsChanged(this.props, nextProps, ['startDate', 'endDate'])) {
      fetchUnmappedImpressions(startDate, endDate, timezone)
    }
  }

  render() {
    const {unmappedImpressions, isUnmappedImpressionFetching} = this.props
    return (
      <div className='impression-view'>
        <div>Below a list of Impressions that are not mapped to any system</div>
        <Table
          data={unmappedImpressions}
          loading={isUnmappedImpressionFetching}
          empty='There are no unmapped impressions'
        >
          <Column
            header='Impressions'
            grow
            cell={data => <Cell className=''>{data.url}</Cell>}
          />
          <Column
            header='Count'
            width='100px'
            cell={data => <Cell className=''>{data.visits}</Cell>}
          />
        </Table>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {startDate, endDate} = getSelectedDateRange(state)
  return {
    startDate,
    endDate,
    unmappedImpressions: getUnmappeImpressions(state),
    isUnmappedImpressionFetching: state.settings.isUnmappedImpressionFetching
  }
}

const mapDispatchToProps = {
  fetchUnmappedImpressions
}

export default connect(mapStateToProps, mapDispatchToProps)(ImpressionView)



// WEBPACK FOOTER //
// ./client/views/DataCollectionView/ImpressionView/index.js